import React from 'react';
import Button from '../UI/Button';

const NewsCard = ({ image, title, excerpt, onReadMore, date }) => {
  return (
    <article className="bg-white border border-gray-200 overflow-hidden rounded-none">
      <div className="h-56 overflow-hidden bg-gray-100">
        {image ? (
          <img 
            src={image} 
            alt={title} 
            className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-emerald-100 to-emerald-200 flex items-center justify-center">
            <span className="text-emerald-400 text-sm">Sem imagem</span>
          </div>
        )}
      </div>
      <div className="p-6">
        {date && (
          <div className="text-sm text-emerald-600 mb-2 font-medium">
            {new Date(date).toLocaleDateString('pt-PT')}
          </div>
        )}
        <h3 className="text-lg font-semibold text-gray-900 mb-3 line-clamp-2">{title}</h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-3">{excerpt}</p>
        <div>
          <Button variant="secondary" onClick={onReadMore}>Ler mais</Button>
        </div>
      </div>
    </article>
  );
};

export default NewsCard;